import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import type { Block } from '../../../../types/proposal-blocks';

type Data = Extract<Block, { type: 'code_block' }>;

export function CodeBlockBlock({ block }: { block: Data }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(block.code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="my-4">
      {block.caption && <p className="text-xs text-proposal-fg3 mb-1 font-proposal-mono">{block.caption}</p>}
      <div className="relative bg-[#0D1117] border border-proposal-border rounded-p-lg p-5 overflow-x-auto">
        <button onClick={handleCopy} className="absolute top-3 right-3 bg-proposal-bg4 border border-proposal-border-strong rounded-p-sm text-proposal-fg3 text-[11px] font-proposal-mono px-2.5 py-0.5 cursor-pointer hover:text-proposal-fg1">
          {copied ? <><Check size={12} className="inline" /> Copiado</> : <><Copy size={12} className="inline" /> Copiar</>}
        </button>
        <pre className="font-proposal-mono text-[13px] leading-[1.7] text-[#e6edf3] whitespace-pre">{block.code}</pre>
      </div>
    </div>
  );
}
